"use client";

import { CMSData } from "@/cms/models";
import { ApplicationFraction } from "@/utils/gql/graphql";
import React from "react";
import { Autoplay, EffectFade, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

export interface SliderComponentProps {
  cmsData: CMSData;
  app: ApplicationFraction;
  items: any[];
  config: {
    navigation?: boolean;
    autoplay?: {
      delay: number;
      disableOnInteraction: boolean;
      pauseOnMouseEnter: boolean;
    };
    slidesPerView?: number | "auto";
    spaceBetween?: string;
    centeredSlides?: boolean;
    speed?: number;
    effect?: string;
  };
}

const SliderClientComponent: React.FC<{
  config: SliderComponentProps;
  items: any[];
}> = ({ config, items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="relative h-full overflow-hidden">
      <Swiper
        className="select-none h-full"
        slidesPerView={config.config.slidesPerView ?? "auto"}
        spaceBetween={config.config.spaceBetween ?? "1px"}
        centeredSlides={config.config.centeredSlides ?? false}
        speed={config.config.speed ?? 500}
        effect={config.config.effect ?? "slide"}
        fadeEffect={{
          crossFade: config.config.effect === "fade",
        }}
        navigation={config.config?.navigation}
        autoplay={
          !config.config?.autoplay
            ? false
            : {
                delay: config.config.autoplay.delay ?? 1000,
                disableOnInteraction:
                  config.config.autoplay.disableOnInteraction ?? true,
                pauseOnMouseEnter:
                  config.config.autoplay.pauseOnMouseEnter ?? false,
              }
        }
        modules={
          [
            config.config.navigation ? Navigation : null,
            config.config.autoplay ? Autoplay : null,
            config.config.effect === "fade" ? EffectFade : null,
          ].filter(Boolean) as any
        }
      >
        {items.map((item, i) => {
          return (
            <SwiperSlide key={i} style={{ width: "80%" }}>
              {item}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default SliderClientComponent;
